import SelectInfiniteScroll from 'components/selectInfiniteScroll/selectInfiniteScroll';
import { useBackEndRequests } from 'pages/Login/lib/backEndRequests';
import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-dsgov';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomConfirmer from '../../../components/customConfirmer/customConfirmer';
import { useAuth } from '../../../hooks/useAuth';
import { maskSelectCpfCnpj, unmaskSelectCpfCnpj } from '../../../utils/formatCNPJOrCPF';
import styles from './pageTitle.module.scss';

function PageTitle() {
  const auth = useAuth();

  const userCpfCnpj = sessionStorage.getItem('userCpfCnpj') || '';

  const { getRepresentantes } = useBackEndRequests();
  const [queryBuscaInput, setQueryBuscaInput] = useState<string>('');
  const [valueSelect, setValueSelect] = useState({
    label: maskSelectCpfCnpj(userCpfCnpj),
    value: userCpfCnpj,
  });

  const [selectedCpfCnpj, setSelectedCpfCnpj] = useState<string>(maskSelectCpfCnpj(userCpfCnpj));

  const [isModalOpened, setIsModalOpened] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (auth.user && !userCpfCnpj) {
      navigate('/login');
    }
  }, [auth.user]);

  const onUserCpfCnpjChange = async (value: { label: string; value: string }) => {
    setValueSelect(value);
    setSelectedCpfCnpj(value?.value.toString() || '');
    if (location.pathname !== '/') setIsModalOpened(true);
    else {
      sessionStorage.setItem('userCpfCnpj', unmaskSelectCpfCnpj(value?.value.toString() || ''));
      navigate(0);
    }
  };

  const confirmChangeCNPJ = async () => {
    sessionStorage.setItem('userCpfCnpj', unmaskSelectCpfCnpj(selectedCpfCnpj));
    setIsModalOpened(false);
    navigate('/');
  };

  const cancelChangeCNPJ = () => {
    setSelectedCpfCnpj(sessionStorage.getItem('userCpfCnpj') || '');
    setValueSelect({
      label: maskSelectCpfCnpj(sessionStorage.getItem('userCpfCnpj') || ''),
      value: sessionStorage.getItem('userCpfCnpj') || '',
    });
    setIsModalOpened(false);
  };

  return (
    <div className={styles.container}>
      <Modal title='Mudar o declarante selecionado' useScrim modalOpened={isModalOpened}>
        <Modal.Body>
          Ao mudar o CNPJ/CPF e o representante declarante selecionado, você será redirecionado para a página inicial.
          Deseja continuar?
        </Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={() => cancelChangeCNPJ()}>
            Cancelar
          </Button>
          <CustomConfirmer asyncCall={() => confirmChangeCNPJ()}>Confirmar</CustomConfirmer>
        </Modal.Footer>
      </Modal>
      <div className={styles.textContainer}>
        <h1 className={styles.title}>Arrecadação - CFEM</h1>
        <p className={styles.subtitle}>
          Geração de Guias de Recolhimento da Compensação Financeira pela Exploração Mineral
        </p>
      </div>

      <div className={styles.selectContainer}>
        {auth.isAuthenticated && userCpfCnpj && (
          <SelectInfiniteScroll
            keyQuery={['projects', queryBuscaInput.replace(/\D/g, '')]}
            customClassName={styles.select}
            functionQuery={async ({ pageParam }) =>
              getRepresentantes(pageParam, 50, queryBuscaInput.replace(/\D/g, ''))
            }
            value={valueSelect}
            onChange={(value: { label: string; value: string }) => onUserCpfCnpjChange(value)}
            queryBuscaInput={queryBuscaInput}
            setQueryBuscaInput={setQueryBuscaInput}
            label='CPF/CNPJ Representado'
            hasIcon
            hasBorder={false}
          />
        )}
      </div>
    </div>
  );
}

export default PageTitle;
